module.exports = __webpack_public_path__ + "static/img/ie-tip.88a84b32.png";